<div class="row">
  <!-- Side menu -->
  <div class="col-lg-1 col-12">
    <app-uiform-side-menu
      [uiformId]="uiformId"
      targetId="list"
      [usecaseId]="usecaseId"
      [appId]="appId"
    >
    </app-uiform-side-menu>
  </div>

  <!-- Main content area -->
  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row">
      <div
        class="d-flex justify-content-between flex-wrap gap-2 align-items-center mb-3"
      >
        <!-- Left: Title -->
        <h5 class="d-flex mb-0 align-items-center justify-content-start">
          <mat-icon color="primary" class="me-2">list</mat-icon>
          <p class="wrap-text mb-0 d-flex align-items-center">
            {{ form.data["title"] }} >
            {{ "Uifromlist.LIST.TITLE" | translate }}
          </p>
        </h5>

        <div>
          <app-list-header [$parent]="getSelf()" class="mt-1"></app-list-header>
        </div>
      </div>

      <div class="col col-md-12">
        <div class="card">
          <!-- Search inputs section -->
          <div class="card-header border-0">
            <div class="rwo">
              <div class="col-12">
                <button
                  mat-stroked-button
                  color="primary"
                  [title]="
                    (showSearchInputs
                      ? 'Uifromlist.LIST.BUTTONS.HIDE_SEARCH'
                      : 'Uifromlist.LIST.BUTTONS.SHOW_SEARCH'
                    ) | translate
                  "
                  (click)="toggleSearchInputs()"
                >
                  <mat-icon>tune</mat-icon>
                  <span>{{ "customReport.filter.title" | translate }}</span>
                </button>
              </div>
            </div>

            <div
              class="row g-2 mt-1 compact-inputs dropdown-pd-none"
              *ngIf="showSearchInputs"
            >
              <div
                class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2"
                *ngFor="let field of filteredFields; let i = index"
              >
                <ng-container *ngIf="getAttributeListById(field.id) as e">
                  <div class="d-flex justify-content-start align-items-center">
                    <ng-container *ngIf="e['refKey'] == 1">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <mat-select
                          [(ngModel)]="searchValues[e.code]"
                          [compareWith]="compareFn"
                          (selectionChange)="
                            onSearchReferenceValueChange1(e, $event.value)
                          "
                          [placeholder]="
                            searchValues[e.code]
                              ? ''
                              : '--Select ' + e.label + ' --'
                          "
                          [panelClass]="{
                            'placeholder-grey':
                              searchValues[e.code] === undefined ||
                              searchValues[e.code] === 'undefined' ||
                              searchValues[e.code] === '' ||
                              searchValues[e.code] === null,
                          }"
                        >
                          <mat-option>
                            <mat-option>
                              <ngx-mat-select-search
                                #searchRefKey
                                [placeholderLabel]="'Search ' + e.label + '...'"
                                noEntriesFoundLabel="No matches found"
                                [clearSearchInput]="true"
                                [hideClearSearchButton]="false"
                              ></ngx-mat-select-search>
                            </mat-option>
                          </mat-option>
                          <mat-option [value]="null">-- None --</mat-option>
                          <ng-container
                            *ngFor="
                              let item of getFilteredData(
                                form.preload?.[e.primaryUsecase] || []
                              )
                            "
                          >
                            <mat-option
                              *ngIf="
                                !searchRefKey.value ||
                                (item._val
                                  ? item._val
                                      .toLowerCase()
                                      .includes(
                                        searchRefKey.value.toLowerCase()
                                      )
                                  : item
                                      ?.toString()
                                      .toLowerCase()
                                      .includes(
                                        searchRefKey.value.toLowerCase()
                                      ))
                              "
                              [value]="item.id"
                            >
                              {{ item._val }}
                            </mat-option>
                          </ng-container>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>

                    <!-- Standard text/number input fields (excludes all special types) -->
                    <ng-container
                      *ngIf="
                        e['refKey'] != 1 &&
                        e['type'] !== 'list' &&
                        e['type'] !== 'file' &&
                        e['type'] !== 'map' &&
                        e['type'] !== 'doc' &&
                        e['type'] !== 'location' &&
                        e['type'] !== 'boolean' &&
                        e['type'] !== 'date' &&
                        e['type'] !== 'time' &&
                        e['type'] !== 'dateandtime' &&
                        e['type'] !== 'idate' &&
                        e['type'] !== 'itime' &&
                        e['type'] !== 'password'
                      "
                    >
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          matInput
                          [type]="getInputType(e.type)"
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          [placeholder]="e.label"
                        />
                      </mat-form-field>
                    </ng-container>

                    <!-- Date -->
                    <ng-container *ngIf="e['type'] === 'date'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <input
                          matInput
                          type="date"
                          #dateInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="dateInput.showPicker()"
                          aria-label="Open date picker"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >event</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- Time -->
                    <ng-container *ngIf="e['type'] === 'time'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <input
                          matInput
                          type="time"
                          #timeInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="timeInput.showPicker()"
                          aria-label="Open time picker"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >schedule</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- Date and Time -->
                    <ng-container *ngIf="e['type'] === 'dateandtime'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <input
                          matInput
                          type="datetime-local"
                          #datetimeInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="datetimeInput.showPicker()"
                          aria-label="Open date and time picker"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >calendar_month</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- iDate -->
                    <ng-container *ngIf="e['type'] === 'idate'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <input
                          matInput
                          type="date"
                          #idateInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="idateInput.showPicker()"
                          aria-label="Open date picker"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >event</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- iTime -->
                    <ng-container *ngIf="e['type'] === 'itime'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <input
                          matInput
                          type="time"
                          #itimeInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="itimeInput.showPicker()"
                          aria-label="Open time picker"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >schedule</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- password -->
                    <ng-container *ngIf="e['type'] === 'password'">
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          matInput
                          [type]="hidePassword ? 'password' : 'text'"
                          #itimeInput
                          [(ngModel)]="searchValues[e.code]"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          (ngModelChange)="onSearchValueChange(e, $event)"
                          placeholder="{{ e.label }}"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          (click)="hidePassword = !hidePassword"
                          [attr.aria-label]="'Hide password'"
                          [attr.aria-pressed]="hidePassword"
                          class="icon-pd-none"
                        >
                          <mat-icon class="icon-compact text-secondary">
                            {{ hidePassword ? "visibility_off" : "visibility" }}
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </ng-container>

                    <!-- List type with ngx-mat-select-search -->
                    <ng-container *ngIf="e['type'] === 'list'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <mat-select
                          [(ngModel)]="searchValues[e.code]"
                          [panelClass]="{
                            'placeholder-grey':
                              searchValues[e.code] === undefined ||
                              searchValues[e.code] === 'undefined' ||
                              searchValues[e.code] === '' ||
                              searchValues[e.code] === null,
                          }"
                        >
                          <mat-option>
                            <ngx-mat-select-search
                              #listSearch
                              [placeholderLabel]="'Search ' + e.label + '...'"
                              noEntriesFoundLabel="No matches found"
                            ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null"
                            >-- Select {{ e.label }} --</mat-option
                          >
                          <ng-container *ngFor="let item of e['values']">
                            <mat-option
                              *ngIf="
                                !listSearch.value ||
                                (item?.self
                                  ? item.self
                                      .toLowerCase()
                                      .includes(listSearch.value.toLowerCase())
                                  : item
                                      ?.toString()
                                      .toLowerCase()
                                      .includes(listSearch.value.toLowerCase()))
                              "
                              [value]="item?.self ? item.self : item"
                            >
                              {{ item?.self ? item.self : item }}
                            </mat-option>
                          </ng-container>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>

                    <!-- Boolean fields -->
                    <ng-container *ngIf="e['type'] === 'boolean'">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ e.label }}</mat-label>
                        <mat-select
                          [(ngModel)]="searchValues[e.code]"
                          [panelClass]="{
                            'placeholder-grey':
                              searchValues[e.code] === undefined,
                          }"
                        >
                          <mat-option [value]="undefined" disabled selected>
                            {{ "Uifromlist.FORM.SELECT_BOOLEAN" | translate }}
                          </mat-option>
                          <mat-option [value]="1">{{
                            "COMMON.TRUE" | translate
                          }}</mat-option>
                          <mat-option [value]="0">{{
                            "COMMON.FALSE" | translate
                          }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>

                    <!-- Info icon (hidden for map, location, doc, file) -->
                    <mat-icon
                      *ngIf="
                        e['type'] !== 'map' &&
                        e['type'] !== 'location' &&
                        e['type'] !== 'doc' &&
                        e['type'] !== 'file'
                      "
                      ncsTooltip
                      [matTooltip]="getDescription(e)"
                      matTooltipPosition="above"
                      class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </div>
                </ng-container>
              </div>

              <!-- Tag search field -->
              <div
                *ngIf="enabletag"
                class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2"
              >
                <div class="d-flex justify-content-start align-items-center">
                  <mat-form-field appearance="outline" class="w-100">
                    <input
                      matInput
                      [type]="getInputType('tag')"
                      [(ngModel)]="searchValues['tag']"
                      id="tag"
                      name="tag"
                      [placeholder]="'Uifromlist.LIST.SEARCH_TAG' | translate"
                    />
                  </mat-form-field>
                  <mat-icon
                    ncsTooltip
                    [matTooltip]="'Uifromlist.LIST.TAG_TOOLTIP' | translate"
                    matTooltipPosition="above"
                    class="text-secondary icon-compact"
                    >info</mat-icon
                  >
                </div>
              </div>

              <!-- Search action buttons -->
              <div class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-2">
                <div class="d-flex gap-2">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="reSearch()"
                  >
                    <mat-icon class="me-1">search</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.SEARCH" | translate }}
                  </button>
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="resetSearch()"
                  >
                    <i class="fa fa-eraser" aria-hidden="true"></i>
                    <span class="ms-2">{{
                      "customReport.buttons.reset" | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Card body with main content -->
          <div class="card-body">
            <!-- Alert messages -->
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert [message]="form['message']" type="success" />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert [message]="form['message']" type="danger" />
            </p>

            <div>
              <!-- Actions row -->
              <div class="d-flex justify-content-between flex-wrap gap-2 mb-3">
                <!-- Left side buttons -->
                <div class="d-flex flex-wrap gap-1">
                  <button
                    *ngIf="usecase?.exportEnabled == 1"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="'Uifromlist.LIST.BUTTONS.CSV' | translate"
                    matTooltipPosition="above"
                    (click)="exportData()"
                  >
                    <mat-icon class="me-1">description</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.EXCEL" | translate }}
                  </button>

                  <button
                    *ngIf="usecase?.exportEnabled == 1"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="'Uifromlist.LIST.BUTTONS.PDF' | translate"
                    matTooltipPosition="above"
                    (click)="exportPDFDataEmail()"
                  >
                    <mat-icon class="me-1">picture_as_pdf</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.PDF" | translate }}
                  </button>

                  <button
                    *ngIf="create === 1 && form.data.readOnly != true"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="
                      'Uifromlist.LIST.BUTTONS.UPLOAD_CSV' | translate
                    "
                    matTooltipPosition="above"
                    (click)="csvfileInput.click()"
                  >
                    <mat-icon class="me-1">upload</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.UPLOAD" | translate }}
                  </button>

                  <input
                    type="file"
                    #csvfileInput
                    class="d-none"
                    accept="csv"
                    (change)="onCsvFileUpload($event)"
                  />

                  <button
                    *ngIf="create === 1 && form.data.readOnly != true"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="
                      'Uifromlist.LIST.BUTTONS.DOWNLOAD_SAMPLE' | translate
                    "
                    matTooltipPosition="above"
                    (click)="exportSampleData()"
                  >
                    <mat-icon class="me-1">download</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.SAMPLE_CSV" | translate }}
                  </button>

                  <button
                    *ngIf="create === 1 || update === 1"
                    mat-stroked-button
                    color="primary"
                    [routerLink]="['/upload-logs', usecaseId]"
                    [matTooltip]="
                      'Uifromlist.LIST.BUTTONS.UPLOAD_ERROR_LOGS' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="me-1">history</mat-icon>
                    {{
                      "Uifromlist.LIST.BUTTONS.UPLOAD_ERROR_LOGS" | translate
                    }}
                  </button>

                  <button
                    *ngIf="create === 1 && form.data.readOnly != true"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="'Uifromlist.LIST.BUTTONS.ADD' | translate"
                    matTooltipPosition="above"
                    (click)="goToForm()"
                  >
                    <mat-icon class="me-1">add</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.ADD" | translate }}
                  </button>

                  <button
                    *ngIf="isDelete === 1"
                    mat-stroked-button
                    color="primary"
                    [matTooltip]="'Uifromlist.LIST.BUTTONS.DELETE' | translate"
                    matTooltipPosition="above"
                    (click)="Deleteall()"
                  >
                    <mat-icon class="icon-compact">delete</mat-icon>
                    {{ "Uifromlist.LIST.BUTTONS.DELETE" | translate }}
                  </button>
                </div>

                <!-- View toggle buttons -->
                <div
                  class="d-flex justify-content-end align-items-center gap-1"
                >
                  <button
                    mat-stroked-button
                    [color]="viewMode === 'table' ? 'primary' : 'basic'"
                    [matTooltip]="'Remains.Table_View' | translate"
                    matTooltipPosition="above"
                    (click)="toggleView('table')"
                    class="icon-center icon-width"
                  >
                    <mat-icon>list</mat-icon>
                  </button>

                  <button
                    mat-stroked-button
                    [color]="viewMode === 'card' ? 'primary' : 'basic'"
                    [matTooltip]="'Remains.Card_View' | translate"
                    matTooltipPosition="above"
                    (click)="toggleView('card')"
                    class="icon-center icon-width"
                  >
                    <mat-icon>dashboard</mat-icon>
                  </button>
                </div>
              </div>

              <!-- TABLE VIEW -->
              <div class="table-container mb-2" *ngIf="viewMode === 'table'">
                <div class="table-responsive table-scrollable">
                  <p
                    *ngIf="
                      form['searchError'] == false && form['searchMessage']
                    "
                  >
                    <app-ncs-alert
                      [message]="form['searchMessage']"
                      type="success"
                    />
                  </p>
                  <p
                    *ngIf="form['searchError'] == true && form['searchMessage']"
                  >
                    <app-ncs-alert
                      [message]="form['searchMessage']"
                      type="danger"
                    />
                  </p>

                  <table
                    *ngIf="read === 1"
                    class="table table-bordered table-hover table-sticky-header"
                  >
                    <thead>
                      <tr>
                        <th *ngIf="isDelete === 1">
                          <mat-checkbox
                            color="primary"
                            [(ngModel)]="masterSelected"
                            (change)="selectAll()"
                            [title]="
                              'Uifromlist.LIST.CHECKBOX.SELECT_ALL' | translate
                            "
                          ></mat-checkbox>
                        </th>
                        <th *ngIf="update === 1">
                          {{ "Uifromlist.LIST.BUTTONS.EDIT" | translate }}
                        </th>
                        <th>{{ "Uifromlist.LIST.HEADERS.SNO" | translate }}</th>
                        <th
                          *ngFor="
                            let field of form.data['fields'];
                            let i = index
                          "
                        >
                          <ng-container
                            *ngIf="getAttributeListById(field.id) as e"
                          >
                            <span (click)="sortTable(e.code)">
                              {{ getFilterLable(field["label"]) }}
                              <i
                                *ngIf="
                                  sortedField === e.code && sortOrder === 'ASC'
                                "
                                class="fa fa-sort-up ms-1"
                              ></i>
                              <i
                                *ngIf="
                                  sortedField === e.code && sortOrder === 'DESC'
                                "
                                class="fa fa-sort-down ms-1"
                              ></i>
                              <i
                                *ngIf="sortedField !== e.code"
                                class="fa fa-sort ms-1"
                              ></i>
                            </span>
                          </ng-container>
                        </th>
                        <th *ngIf="enabletag > 0">
                          {{ "Uifromlist.LIST.HEADERS.TAGS" | translate }}
                        </th>
                        <th *ngIf="isDelete === 1">
                          {{ "Uifromlist.LIST.BUTTONS.DELETE" | translate }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <ng-container *ngIf="filteredData.length > 0">
                        <tr *ngFor="let e of filteredData; let i = index">
                          <td
                            [ngStyle]="{
                              'min-width':
                                form.data.fields.length > 5 ? '50px' : '0px',
                            }"
                            *ngIf="isDelete === 1"
                          >
                            <mat-checkbox
                              color="primary"
                              [(ngModel)]="e.selected"
                              (change)="checkIfAllSelected()"
                              [title]="
                                'Uifromlist.LIST.CHECKBOX.SELECT_ITEM'
                                  | translate
                              "
                            ></mat-checkbox>
                          </td>

                          <td
                            [ngStyle]="{
                              'min-width':
                                form.data.fields.length > 5 ? '50px' : '0px',
                            }"
                            *ngIf="
                              update === 1 || form.data.readOnly === 'true'
                            "
                          >
                            <div
                              class="btn-group"
                              *ngIf="form.data.readOnly === true"
                            >
                              <button
                                mat-icon-button
                                color="primary"
                                class="icon-pd-none"
                                [matTooltip]="
                                  'Uifromlist.LIST.BUTTONS.VIEW' | translate
                                "
                                matTooltipPosition="above"
                                [routerLink]="[
                                  '/uiform/' + uiformId + '/' + e['id'],
                                ]"
                              >
                                <mat-icon>visibility</mat-icon>
                              </button>
                            </div>

                            <div *ngIf="form.data.readOnly != true">
                              <button
                                mat-icon-button
                                color="primary"
                                class="icon-pd-none"
                                [routerLink]="[
                                  '/uiform/' + uiformId + '/' + e['id'],
                                ]"
                                [title]="
                                  'Uifromlist.LIST.BUTTONS.EDIT' | translate
                                "
                              >
                                <mat-icon class="icon-compact">edit</mat-icon>
                              </button>
                            </div>
                          </td>

                          <td
                            [ngStyle]="{
                              'min-width':
                                form.data.fields.length > 5 ? '50px' : '0px',
                            }"
                          >
                            {{ pageIndex(i) }}
                          </td>

                          <td
                            *ngFor="
                              let field of form.data['fields'];
                              let i = index
                            "
                            (dblclick)="startEditing(e, field)"
                          >
                            <ng-container
                              *ngIf="getAttributeListById(field.id) as at"
                            >
                              <!-- Display Mode -->
                              <div
                                *ngIf="!e.editing || e.editingField !== at.code"
                              >
                                <ng-container *ngIf="at.refKey == 1">
                                  {{ getPreloadedLabel(at, e[at.code]) }}
                                </ng-container>
                                <ng-container *ngIf="at.refKey != 1">
                                  <span
                                    *ngIf="
                                      at['type'] === 'object' &&
                                      at['type'] != 'file' &&
                                      at['type'] != 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'number' &&
                                      at['type'] !== 'text' &&
                                      at['type'] !== 'json'
                                    "
                                  >
                                    {{ e[at["code"]] | json }}
                                  </span>
                                  <span
                                    *ngIf="
                                      at['type'] != 'object' &&
                                      at['type'] != 'file' &&
                                      at['type'] != 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] != 'dateandtime' &&
                                      at['type'] != 'itime' &&
                                      at['type'] != 'textarea' &&
                                      at['type'] != 'email' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'text' &&
                                      at['type'] != 'list' &&
                                      at['type'] != 'map' &&
                                      at['type'] !== 'number' &&
                                      at['type'] !== 'idate' &&
                                      at['type'] !== 'json'
                                    "
                                  >
                                    {{
                                      at["depAttribute"]
                                        ? getString(
                                            e[at["depAttribute"]],
                                            at["type"]
                                          )
                                        : getString(e[at["code"]], at["type"])
                                    }}
                                  </span>
                                  <span *ngIf="at['type'] === 'time'">
                                    {{
                                      at["depAttribute"]
                                        ? getString1(
                                            e[at["depAttribute"]],
                                            at["type"],
                                            at["timeFormat"]
                                          )
                                        : getString1(
                                            e[at["code"]],
                                            at["type"],
                                            at["timeFormat"]
                                          )
                                    }}
                                  </span>
                                  <span *ngIf="at['type'] === 'itime'">
                                    {{
                                      at["depAttribute"]
                                        ? getStringitime(
                                            e[at["depAttribute"]],
                                            at["type"],
                                            at["itimeFormat"]
                                          )
                                        : getStringitime(
                                            e[at["code"]],
                                            at["type"],
                                            at["itimeFormat"]
                                          )
                                    }}
                                  </span>
                                  <span
                                    *ngIf="
                                      at['type'] === 'dateandtime' ||
                                      at['type'] == 'idate'
                                    "
                                  >
                                    {{
                                      at["depAttribute"]
                                        ? getString(
                                            e[at["depAttribute"]],
                                            at["type"]
                                          )
                                        : getString(e[at["code"]], at["type"])
                                    }}
                                  </span>
                                  <span *ngIf="at['type'] === 'location'">
                                    <ng-container
                                      *ngIf="
                                        getLocationObject(
                                          at['depAttribute']
                                            ? e[at['depAttribute']]
                                            : e[at['code']]
                                        ) as loc
                                      "
                                    >
                                      <a
                                        [href]="
                                          'https://www.google.com/maps?q=' +
                                          loc.lat +
                                          ',' +
                                          loc.lng
                                        "
                                        target="_blank"
                                        style="text-decoration: none"
                                      >
                                        {{ loc.lat }},{{ loc.lng }}
                                      </a>
                                    </ng-container>
                                  </span>
                                  <span
                                    *ngIf="
                                      at['type'] != 'list' &&
                                      at['type'] != 'object' &&
                                      at['type'] === 'file' &&
                                      at['type'] != 'doc' &&
                                      at['type'] != 'time' &&
                                      e['type'] !== 'location' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'number' &&
                                      at['type'] !== 'text'
                                    "
                                  >
                                    <a
                                      href="{{ getAppDoc(e[at['code']]) }}"
                                      target="_blank"
                                    >
                                      <img
                                        src="{{
                                          getAppDocThumbnail(e[at['code']])
                                        }}"
                                        width="50px"
                                        height="40px"
                                      />
                                    </a>
                                  </span>
                                  <span *ngIf="at['type'] === 'boolean'">
                                    {{
                                      e[at["code"]] == 1
                                        ? ("COMMON.TRUE" | translate)
                                        : e[at["code"]] == 0
                                          ? ("COMMON.FALSE" | translate)
                                          : ""
                                    }}
                                  </span>
                                  <span
                                    *ngIf="at['type'] === 'list'"
                                    [title]="e[at['code']]"
                                  >
                                    {{
                                      e[at["code"]] === null ||
                                      e[at["code"]] == undefined ||
                                      e[at["code"]] == "undefined"
                                        ? ""
                                        : e[at["code"]]
                                    }}
                                  </span>
                                  <span *ngIf="at['type'] === 'map'">
                                    {{
                                      e[at["code"]] === null ||
                                      e[at["code"]] == undefined ||
                                      e[at["code"]] == "undefined"
                                        ? ""
                                        : e[at["code"]]
                                    }}
                                  </span>
                                  <div
                                    *ngIf="at['type'] === 'textarea'"
                                    class="custom-textarea"
                                    [innerHTML]="
                                      getSanitizedHtml(e[at['code']])
                                    "
                                  ></div>
                                  <div
                                    *ngIf="at['type'] === 'json'"
                                    class="custom-textarea"
                                    [innerHTML]="
                                      getSanitizedHtml(e[at['code']])
                                    "
                                  ></div>
                                  <span *ngIf="at['type'] === 'email'">
                                    <a
                                      href="mailto:{{ e[at['code']] }}"
                                      target="_blank"
                                      >{{ e[at["code"]] }}</a
                                    >
                                  </span>
                                  <span
                                    *ngIf="
                                      at['type'] != 'list' &&
                                      at['type'] != 'object' &&
                                      at['type'] !== 'file' &&
                                      at['type'] === 'doc' &&
                                      at['type'] !== 'number' &&
                                      at['type'] !== 'text'
                                    "
                                  >
                                    <a
                                      href="{{ getAppDoc(e[at['code']]) }}"
                                      target="_blank"
                                    >
                                      <img
                                        src="{{
                                          getAppDocThumbnail(e[at['code']])
                                        }}"
                                        width="50px"
                                      />
                                    </a>
                                  </span>
                                  <span
                                    *ngIf="
                                      at['type'] === 'text' ||
                                      at['type'] === 'number'
                                    "
                                  >
                                    <!-- QR Code -->
                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'qr' && e[at['code']]
                                      "
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        [title]="e[at['code']]"
                                        (click)="
                                          openCodeInNewTab(
                                            'qr',
                                            e[at['code']].toString()
                                          )
                                        "
                                        class="code-link"
                                      >
                                        <div class="code-container">
                                          <qrcode
                                            [qrdata]="e[at['code']].toString()"
                                            [width]="50"
                                            [errorCorrectionLevel]="'M'"
                                          ></qrcode>
                                          <div class="code-text">
                                            {{ e[at["code"]] | truncate: 10 }}
                                          </div>
                                        </div>
                                      </a>
                                    </ng-container>
                                    <!-- Barcode -->
                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'bar' &&
                                        e[at['code']]
                                      "
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        [title]="e[at['code']]"
                                        (click)="
                                          openCodeInNewTab(
                                            'bar',
                                            e[at['code']].toString()
                                          )
                                        "
                                        class="code-link"
                                      >
                                        <div class="code-container">
                                          <ngx-barcode6
                                            [bc-value]="
                                              e[at['code']].toString()
                                            "
                                            bc-format="CODE128"
                                            [bc-display-value]="false"
                                            [bc-width]="0.8"
                                            [bc-height]="20"
                                          ></ngx-barcode6>
                                          <div class="code-text mt-0">
                                            {{ e[at["code"]] | truncate: 10 }}
                                          </div>
                                        </div>
                                      </a>
                                    </ng-container>
                                    <!-- Plain Text (none) -->
                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'none' ||
                                        !at['codeType'] ||
                                        !e[at['code']]
                                      "
                                    >
                                      <span [title]="e[at['code']]">{{
                                        e[at["code"]] | truncate: 40
                                      }}</span>
                                    </ng-container>
                                  </span>
                                </ng-container>
                              </div>

                              <!-- Edit Mode - Inline Fields -->
                              <div
                                *ngIf="
                                  e.editing &&
                                  e.editingField === at.code &&
                                  !(
                                    at.type === 'textarea' &&
                                    at.enableEditor == 1
                                  )
                                "
                                class="editable-cell"
                              >
                                <select
                                  *ngIf="
                                    at.refKey == 1 &&
                                    form.preload?.[at.primaryUsecase]?.length
                                  "
                                  [(ngModel)]="e[at.code]"
                                  (blur)="stopEditing(e, at)"
                                  class="form-control form-control-sm"
                                >
                                  <option
                                    *ngFor="
                                      let c of form.preload[at.primaryUsecase]
                                    "
                                    [value]="c.id"
                                  >
                                    {{ c._val }}
                                  </option>
                                </select>
                                <select
                                  *ngIf="
                                    at.type === 'boolean' && at.refKey != 1
                                  "
                                  [(ngModel)]="e[at.code]"
                                  (blur)="stopEditing(e, at)"
                                  class="form-control form-control-sm"
                                >
                                  <option [value]="1">
                                    {{ "COMMON.TRUE" | translate }}
                                  </option>
                                  <option [value]="0">
                                    {{ "COMMON.FALSE" | translate }}
                                  </option>
                                </select>
                                <select
                                  *ngIf="at.type === 'list' && at.refKey != 1"
                                  [(ngModel)]="e[at.code]"
                                  (blur)="stopEditing(e, at)"
                                  class="form-control form-control-sm"
                                >
                                  <option
                                    *ngFor="let opt of at.values"
                                    [value]="opt"
                                  >
                                    {{ opt }}
                                  </option>
                                </select>
                                <textarea
                                  *ngIf="
                                    at.type === 'textarea' &&
                                    at.enableEditor != 1
                                  "
                                  [ngModel]="e[at.code]"
                                  (ngModelChange)="
                                    handleTextareaChange(e.id, at.code, $event)
                                  "
                                  (blur)="stopEditing(e, at)"
                                  (keyup.enter)="stopEditing(e, at)"
                                  class="form-control form-control-sm"
                                ></textarea>
                                <input
                                  *ngIf="
                                    !['textarea', 'boolean', 'list'].includes(
                                      at.type
                                    ) && at.refKey != 1
                                  "
                                  type="text"
                                  [(ngModel)]="e[at.code]"
                                  (blur)="stopEditing(e, at)"
                                  (keyup.enter)="stopEditing(e, at)"
                                  class="form-control form-control-sm"
                                />
                              </div>

                              <!-- Rich Text Editor Modal -->
                              <div
                                *ngIf="
                                  e.editing &&
                                  e.editingField === at.code &&
                                  at.type === 'textarea' &&
                                  at.enableEditor == 1
                                "
                                class="modal fade show d-block"
                                tabindex="-1"
                                role="dialog"
                                style="background: rgba(0, 0, 0, 0.5)"
                              >
                                <div
                                  class="modal-dialog modal-lg"
                                  role="document"
                                >
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5 class="modal-title">
                                        {{
                                          "Uifromlist.LIST.EDIT_MODAL.TITLE"
                                            | translate
                                        }}
                                      </h5>
                                      <button
                                        type="button"
                                        class="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        (click)="cancelEditing(e)"
                                        [title]="
                                          'Uifromlist.LIST.EDIT_MODAL.CLOSE'
                                            | translate
                                        "
                                      ></button>
                                    </div>
                                    <div class="modal-body">
                                      <ngx-editor-menu
                                        [editor]="
                                          getEditorInstance(e.id, at.code)
                                        "
                                        [toolbar]="toolbar"
                                      ></ngx-editor-menu>
                                      <ngx-editor
                                        [editor]="
                                          getEditorInstance(e.id, at.code)
                                        "
                                        [(ngModel)]="e[at.code]"
                                        (ngModelChange)="
                                          onEditorContentChange(
                                            e.id,
                                            at.code,
                                            $event
                                          )
                                        "
                                        [placeholder]="
                                          'Uifromlist.LIST.EDIT_MODAL.PLACEHOLDER'
                                            | translate
                                        "
                                        class="custom-editor"
                                      ></ngx-editor>
                                    </div>
                                    <div class="modal-footer">
                                      <button
                                        mat-stroked-button
                                        color="primary"
                                        [title]="
                                          'Uifromlist.LIST.EDIT_MODAL.CANCEL'
                                            | translate
                                        "
                                        (click)="cancelEditing(e)"
                                      >
                                        <mat-icon>close</mat-icon>
                                        {{
                                          "Uifromlist.LIST.EDIT_MODAL.CANCEL"
                                            | translate
                                        }}
                                      </button>
                                      <button
                                        mat-stroked-button
                                        color="primary"
                                        data-bs-dismiss="modal"
                                        [title]="
                                          'Uifromlist.LIST.EDIT_MODAL.SAVE'
                                            | translate
                                        "
                                        (click)="stopEditing(e, at)"
                                      >
                                        <mat-icon>save</mat-icon>
                                        {{
                                          "Uifromlist.LIST.EDIT_MODAL.SAVE"
                                            | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </td>

                          <td *ngIf="enabletag">
                            <span
                              *ngIf="enabletag > 0"
                              class="d-flex align-items-start gap-2"
                            >
                              <button
                                type="button"
                                class="btn btn-light overflow-hidden text-truncate btn-sm tagbtn"
                                data-bs-toggle="modal"
                                data-bs-target="#tagsModal"
                                (click)="allAttribute(e, i)"
                                [title]="getCleanTag(e['tag'])"
                              >
                                <ng-container
                                  *ngIf="
                                    getCleanTag(e['tag']) !==
                                      ('Uifromlist.LIST.TAGS.ADD' | translate);
                                    else showTagIcon
                                  "
                                >
                                  {{ getCleanTag(e["tag"]) }}
                                </ng-container>
                                <ng-template #showTagIcon>
                                  <i class="bi bi-tag"></i>
                                </ng-template>
                              </button>
                            </span>
                          </td>

                          <td
                            *ngIf="
                              isDelete === 1 || form.data.readOnly == 'true'
                            "
                          >
                            <div
                              class="btn-group"
                              *ngIf="form.data.readOnly == true"
                            >
                              <button
                                mat-stroked-button
                                color="primary"
                                [matTooltip]="
                                  'Uifromlist.LIST.BUTTONS.VIEW' | translate
                                "
                                matTooltipPosition="above"
                                [routerLink]="[
                                  '/uiform/' + uiformId + '/' + e['id'],
                                ]"
                              >
                                <mat-icon>visibility</mat-icon>
                                <span>{{
                                  "Uifromlist.LIST.BUTTONS.VIEW" | translate
                                }}</span>
                              </button>
                            </div>
                            <div *ngIf="form.data.readOnly != true">
                              <button
                                *ngIf="isDelete === 1"
                                mat-stroked-button
                                class="icon-width icon-center"
                                color="warn"
                                [matTooltip]="
                                  'Uifromlist.LIST.BUTTONS.DELETE' | translate
                                "
                                matTooltipPosition="above"
                                (click)="onDelete(e['id'])"
                              >
                                <mat-icon class="icon-compact">delete</mat-icon>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- CARD VIEW -->
              <div *ngIf="viewMode === 'card'" class="container-fluid mt-3">
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>

                <div class="row" *ngIf="read === 1">
                  <div
                    class="col-12 col-sm-6 col-lg-4 card-row"
                    *ngFor="let e of filteredData; let i = index"
                  >
                    <div
                      class="card h-100 shadow-md border-0 rounded-3 overflow-hidden hover-lift"
                    >
                      <div class="card-header">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span
                            class="badge bg-light text-dark rounded-pill px-3 py-2"
                          >
                            <i class="bi bi-hash me-1"></i
                            >{{ "Uifromlist.LIST.HEADERS.SNO" | translate }}:
                            {{ pageIndex(i) }}
                          </span>
                          <div
                            class="d-flex gap-2"
                            *ngIf="form.data.readOnly != 'true'"
                          >
                            <a
                              *ngIf="update === 1"
                              mat-stroked-button
                              class="icon-center icon-width small-button"
                              color="primary"
                              [routerLink]="[
                                '/uiform/' + uiformId + '/' + e['id'],
                              ]"
                              [matTooltip]="
                                'Uifromlist.LIST.BUTTONS.EDIT' | translate
                              "
                            >
                              <mat-icon>edit</mat-icon>
                            </a>
                            <button
                              mat-stroked-button
                              class="icon-center icon-width small-button"
                              color="primary"
                              [matTooltip]="'COMMON.VIEW' | translate"
                              type="button"
                              (click)="openViewModal(e)"
                            >
                              <mat-icon class="icon-compact"
                                >visibility</mat-icon
                              >
                            </button>
                            <button
                              *ngIf="isDelete === 1"
                              mat-stroked-button
                              class="icon-center icon-width small-button"
                              color="warn"
                              [matTooltip]="
                                'Uifromlist.LIST.BUTTONS.DELETE' | translate
                              "
                              (click)="onDelete(e['id'])"
                            >
                              <mat-icon class="icon-compact">delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="card-body p-3"
                        style="max-height: 400px; overflow-y: auto"
                      >
                        <div class="vstack gap-2">
                          <div
                            *ngFor="
                              let field of form.data['fields'];
                              let i = index
                            "
                            class="border-bottom pb-2 last:border-0 last:pb-0"
                          >
                            <ng-container
                              *ngIf="getAttributeListById(field.id) as at"
                            >
                              <ng-container
                                *ngIf="getFilterLable(field['label']) as label"
                              >
                                <!-- Field Label -->
                                <small
                                  class="text-muted text-uppercase fw-semibold"
                                  >{{ label }}</small
                                >

                                <!-- Field Value -->
                                <div class="mt-1">
                                  <!-- Object Type -->
                                  <span
                                    *ngIf="
                                      at['type'] === 'object' &&
                                      at['type'] !== 'file' &&
                                      at['type'] !== 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'email' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'itime' &&
                                      at['type'] !== 'idate' &&
                                      at['type'] !== 'json'
                                    "
                                    class="badge bg-light text-dark p-2"
                                  >
                                    {{ e[at["code"]] | json }}
                                  </span>

                                  <!-- Default String Types -->
                                  <span
                                    *ngIf="
                                      at['type'] !== 'object' &&
                                      at['type'] !== 'file' &&
                                      at['type'] !== 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'email' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'list' &&
                                      at['type'] !== 'map' &&
                                      at['type'] !== 'textarea' &&
                                      at['type'] !== 'itime' &&
                                      at['type'] !== 'idate' &&
                                      at['type'] !== 'json' &&
                                      at['type'] !== 'text' &&
                                      at['type'] !== 'number'
                                    "
                                    class="fw-medium"
                                  >
                                    {{
                                      at["depAttribute"]
                                        ? getString(
                                            e[at["depAttribute"]],
                                            at["type"]
                                          )
                                        : getString(e[at["code"]], at["type"])
                                    }}
                                  </span>

                                  <!-- Text / Number with QR/Barcode Support -->
                                  <span
                                    *ngIf="
                                      at['type'] === 'text' ||
                                      at['type'] === 'number'
                                    "
                                    class="d-block"
                                  >
                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'qr' && e[at['code']]
                                      "
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        [title]="e[at['code']]"
                                        (click)="
                                          openCodeInNewTab(
                                            'qr',
                                            e[at['code']].toString()
                                          )
                                        "
                                        class="code-link text-decoration-none"
                                      >
                                        <div
                                          style="
                                            display: inline-flex;
                                            flex-direction: column;
                                            align-items: center;
                                            width: 50px;
                                          "
                                        >
                                          <qrcode
                                            [qrdata]="e[at['code']].toString()"
                                            [width]="50"
                                            [errorCorrectionLevel]="'M'"
                                          ></qrcode>
                                          <div
                                            style="
                                              font-size: 11px;
                                              color: #2e2e2e;
                                              text-align: center;
                                              width: 100%;
                                            "
                                            class="mt-1"
                                          >
                                            {{ e[at["code"]] | truncate: 10 }}
                                          </div>
                                        </div>
                                      </a>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'bar' &&
                                        e[at['code']]
                                      "
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        [title]="e[at['code']]"
                                        (click)="
                                          openCodeInNewTab(
                                            'bar',
                                            e[at['code']].toString()
                                          )
                                        "
                                        class="code-link text-decoration-none"
                                      >
                                        <div
                                          style="
                                            display: inline-flex;
                                            flex-direction: column;
                                            align-items: center;
                                          "
                                        >
                                          <ngx-barcode6
                                            [bc-value]="
                                              e[at['code']].toString()
                                            "
                                            bc-format="CODE128"
                                            [bc-display-value]="false"
                                            [bc-width]="0.8"
                                            [bc-height]="20"
                                          ></ngx-barcode6>
                                          <div
                                            style="
                                              font-size: 11px;
                                              color: #363636;
                                              text-align: center;
                                              width: 100%;
                                            "
                                            class="mt-1"
                                          >
                                            {{ e[at["code"]] | truncate: 10 }}
                                          </div>
                                        </div>
                                      </a>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="
                                        at['codeType'] === 'none' ||
                                        !at['codeType'] ||
                                        !e[at['code']]
                                      "
                                    >
                                      <span
                                        class="fw-medium"
                                        [title]="e[at['code']]"
                                        >{{
                                          e[at["code"]] | truncate: 40
                                        }}</span
                                      >
                                    </ng-container>
                                  </span>

                                  <!-- Location Type -->
                                  <span
                                    *ngIf="at['type'] === 'location'"
                                    class="d-inline-block"
                                  >
                                    <ng-container
                                      *ngIf="
                                        getLocationObject(
                                          at['depAttribute']
                                            ? e[at['depAttribute']]
                                            : e[at['code']]
                                        ) as loc
                                      "
                                    >
                                      <a
                                        [href]="
                                          'https://www.google.com/maps?q=' +
                                          loc.lat +
                                          ',' +
                                          loc.lng
                                        "
                                        target="_blank"
                                        class="btn btn-sm btn-link p-0 text-decoration-none"
                                      >
                                        <i class="bi bi-geo-alt-fill me-1"></i
                                        >{{ loc.lat }},
                                        {{ loc.lng }}
                                      </a>
                                    </ng-container>
                                  </span>

                                  <!-- File Type -->
                                  <span
                                    *ngIf="
                                      at['type'] !== 'list' &&
                                      at['type'] !== 'object' &&
                                      at['type'] === 'file' &&
                                      at['type'] !== 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'email' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'idate' &&
                                      at['type'] !== 'json'
                                    "
                                  >
                                    <a
                                      href="{{ getAppDoc(e[at['code']]) }}"
                                      target="_blank"
                                      class="d-inline-block"
                                    >
                                      <img
                                        src="{{
                                          getAppDocThumbnail(e[at['code']])
                                        }}"
                                        class="img-thumbnail rounded-3"
                                        width="60"
                                        alt="File preview"
                                      />
                                    </a>
                                  </span>

                                  <!-- Email Type -->
                                  <span *ngIf="at['type'] === 'email'">
                                    <a
                                      href="mailto:{{ e[at['code']] }}"
                                      target="_blank"
                                      class="text-decoration-none"
                                    >
                                      <i class="bi bi-envelope me-1"></i
                                      >{{ e[at["code"]] }}
                                    </a>
                                  </span>

                                  <!-- Textarea Type -->
                                  <div
                                    *ngIf="at['type'] === 'textarea'"
                                    class="p-2 bg-light rounded-3 text-wrap"
                                    [innerHTML]="
                                      getSanitizedHtml(e[at['code']])
                                    "
                                  ></div>

                                  <!-- Json -->
                                  <div
                                    *ngIf="at['type'] === 'json'"
                                    class="p-2 bg-light rounded-3 text-wrap"
                                    [innerHTML]="
                                      getSanitizedHtml(e[at['code']])
                                    "
                                  ></div>

                                  <!-- Time Type -->
                                  <span
                                    *ngIf="at['type'] === 'time'"
                                    class="badge bg-secondary bg-opacity-10 text-dark p-2"
                                  >
                                    <i class="bi bi-clock me-1"></i>
                                    {{
                                      at["depAttribute"]
                                        ? getString1(
                                            e[at["depAttribute"]],
                                            at["type"],
                                            at["timeFormat"]
                                          )
                                        : getString1(
                                            e[at["code"]],
                                            at["type"],
                                            at["timeFormat"]
                                          )
                                    }}
                                  </span>

                                  <!-- iTime Type -->
                                  <span
                                    *ngIf="at['type'] === 'itime'"
                                    class="badge bg-secondary bg-opacity-10 text-dark p-2"
                                  >
                                    <i class="bi bi-hourglass-split me-1"></i>
                                    {{
                                      at["depAttribute"]
                                        ? getStringitime(
                                            e[at["depAttribute"]],
                                            at["type"],
                                            at["itimeFormat"]
                                          )
                                        : getStringitime(
                                            e[at["code"]],
                                            at["type"],
                                            at["itimeFormat"]
                                          )
                                    }}
                                  </span>

                                  <!-- Boolean Type -->
                                  <span *ngIf="at['type'] === 'boolean'">
                                    <span
                                      class="badge"
                                      [ngClass]="
                                        e[at['code']] == 1
                                          ? 'bg-success'
                                          : 'bg-secondary'
                                      "
                                    >
                                      <i
                                        class="bi"
                                        [ngClass]="
                                          e[at['code']] == 1
                                            ? 'bi-check-circle'
                                            : 'bi-x-circle'
                                        "
                                      ></i>
                                      {{
                                        e[at["code"]] == 1
                                          ? "Yes"
                                          : e[at["code"]] == 0
                                            ? "No"
                                            : ""
                                      }}
                                    </span>
                                  </span>

                                  <!-- List Type -->
                                  <span
                                    *ngIf="at['type'] === 'list'"
                                    class="p-2 listtext"
                                    [title]="e[at['code']]"
                                  >
                                    <i class="bi bi-list me-1"></i>
                                    {{
                                      e[at["code"]] === null ||
                                      e[at["code"]] == undefined ||
                                      e[at["code"]] == "undefined"
                                        ? ""
                                        : e[at["code"]]
                                    }}
                                  </span>

                                  <!-- Map Type -->
                                  <span
                                    *ngIf="at['type'] === 'map'"
                                    class="badge bg-info bg-opacity-10 text-info p-2"
                                  >
                                    <i class="bi bi-map me-1"></i>
                                    {{
                                      e[at["code"]] === null ||
                                      e[at["code"]] == undefined ||
                                      e[at["code"]] == "undefined"
                                        ? ""
                                        : e[at["code"]]
                                    }}
                                  </span>

                                  <!-- Doc Type -->
                                  <span
                                    *ngIf="
                                      at['type'] !== 'list' &&
                                      at['type'] !== 'object' &&
                                      at['type'] !== 'file' &&
                                      at['type'] === 'doc' &&
                                      at['type'] != 'time' &&
                                      at['type'] != 'itime' &&
                                      at['type'] !== 'location' &&
                                      at['type'] !== 'boolean' &&
                                      at['type'] !== 'email' &&
                                      at['type'] !== 'json'
                                    "
                                  >
                                    <a
                                      href="{{ getAppDoc(e[at['code']]) }}"
                                      target="_blank"
                                      class="d-inline-block"
                                    >
                                      <img
                                        src="{{
                                          getAppDocThumbnail(e[at['code']])
                                        }}"
                                        class="img-thumbnail rounded-3"
                                        width="60"
                                        alt="Document preview"
                                      />
                                    </a>
                                  </span>

                                  <!-- iDate Type -->
                                  <span
                                    *ngIf="at['type'] === 'idate'"
                                    class="badge bg-warning bg-opacity-10 text-warning p-2"
                                  >
                                    <i class="bi bi-calendar me-1"></i>
                                    {{
                                      at["depAttribute"]
                                        ? getString(
                                            e[at["depAttribute"]],
                                            at["type"]
                                          )
                                        : getString(e[at["code"]], at["type"])
                                    }}
                                  </span>
                                </div>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mobile-full-width mt-3">
                <app-list-header [$parent]="getSelf()"></app-list-header>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tags Modal — kept exactly as original user-side -->
<!-- <div
  id="tagsModal"
  class="modal fade"
  tabindex="-1"
  aria-labelledby="tagsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tagsModalLabel">Tags</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
       
        <div class="d-flex align-items-center">
          <input
            #tagInput
            type="text"
            class="form-control form-control-sm combobox1"
            placeholder="Enter tags (comma separated)"
            (input)="onUserInput($event)"
            [(ngModel)]="inputValue"
          />
          <div class="input-group-append">
            <button class="tag-add-btn me-1" type="button" (click)="saveTags()">
              +
            </button>
          </div>
          <div>
            <button
              type="button"
              class="btn-close"
              (click)="tagInput.value = ''; inputValue = ''"
            ></button>
          </div>
        </div>
   
        <div class="tag-list-scroll">
          <div
            class="form-check"
            *ngFor="let tag of filteredTagsList; let i = index"
          >
            <input
              class="form-check-input"
              type="checkbox"
              [id]="'tagCheckbox' + i"
              [checked]="selectedTags.includes(tag)"
              (change)="onTagCheckboxChange(tag, $event)"
            />
            <label class="form-check-label" [for]="'tagCheckbox' + i"
              >{{ tag }} raman</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div
  id="tagsModal"
  class="modal fade compact-inputs dropdown-pd-none"
  tabindex="-1"
  aria-labelledby="tagsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tagsModalLabel">
          <i class="bi bi-tags me-2"></i>{{ "Tag.TAG" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="mb-4">
          <label class="form-label fw-semibold mb-2 d-block">{{
            "Tag.ADD_TAG" | translate
          }}</label>
          <div class="d-flex flex-sm-nowrap flex-wrap align-items-center gap-2">
            <mat-form-field
              appearance="outline"
              class="w-100"
              subscriptSizing="dynamic"
            >
              <mat-label>{{ "Tag.TAG_PLACE" | translate }}</mat-label>
              <input
                #tagInput
                matInput
                type="text"
                (input)="onUserInput($event)"
                [(ngModel)]="inputValue"
                placeholder="{{ 'Tag.Tag_Place' | translate }}"
              />
            </mat-form-field>

            <button
              mat-stroked-button
              type="button"
              color="primary"
              class="icon-center icon-width"
              (click)="saveTags()"
              matTooltip="{{ 'Tag.ADD_TAGS' | translate }}"
              matTooltipPosition="above"
            >
              <mat-icon>add</mat-icon>
              <span>{{ "Tag.ADD" | translate }}</span>
            </button>

            <button
              mat-stroked-button
              color="warn"
              type="button"
              class="icon-center icon-width"
              (click)="tagInput.value = ''; inputValue = ''"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <span class="d-flex align-items-center mt-2">
            <i class="bi bi-info-circle text-muted me-2"></i>
            <small class="text-muted">{{ "Tag.TAG_INFO" | translate }}</small>
          </span>
        </div>

        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label fw-semibold mb-0">{{
              "Tag.Available_Tags" | translate
            }}</label>
            <span class="badge bg-secondary"
              >{{ filteredTagsList.length }} {{ "Tag.TAG" | translate }}</span
            >
          </div>

          <div
            class="border rounded p-2 bg-light tag-list-scroll"
            style="max-height: 250px; overflow-y: auto"
          >
            <div
              class="py-1"
              *ngFor="let tag of filteredTagsList; let i = index"
            >
              <mat-checkbox
                [checked]="selectedTags.includes(tag)"
                (change)="onTagCheckboxChange(tag, $event)"
                color="primary"
              >
                <span class="ms-1">{{ tag }}</span>
              </mat-checkbox>
            </div>

            <div
              *ngIf="filteredTagsList.length === 0"
              class="text-center py-3 text-muted"
            >
              <small>{{ "Tag.No_tags_found" | translate }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "Tag.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- View Details Modal -->
<div
  class="modal fade"
  id="viewDetailsModal"
  tabindex="-1"
  aria-labelledby="viewDetailsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title text-wrap text-break" id="viewDetailsModalLabel">
          <i class="fas fa-table me-2"></i>{{ form.data["title"] }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="table-container" *ngIf="selectedEntry" id="printableArea">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="40%" class="text-dark">
                    {{ "Remains.FIELD" | translate }}
                  </th>
                  <th width="60%" class="text-dark">
                    {{ "Remains.VALUE" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let field of form.data['fields']">
                  <ng-container *ngIf="getAttributeListById(field.id) as at">
                    <td class="fw-semibold text-dark">
                      {{ getFilterLable(field["label"]) }}
                    </td>
                    <td class="fw-medium text-dark">
                      <!-- Reference fields (refKey == 1) -->
                      <ng-container *ngIf="at.refKey == 1">
                        {{ getPreloadedLabel(at, selectedEntry[at["code"]]) }}
                      </ng-container>

                      <!-- 📷 File or Document -->
                      <ng-container
                        *ngIf="at['type'] === 'file' || at['type'] === 'doc'"
                      >
                        <a
                          *ngIf="selectedEntry[at['code']]"
                          [href]="getAppDoc(selectedEntry[at['code']])"
                          target="_blank"
                        >
                          <img
                            [src]="
                              getAppDocThumbnail(selectedEntry[at['code']])
                            "
                            alt="File Thumbnail"
                            width="80"
                            class="rounded border"
                          />
                        </a>
                        <span *ngIf="!selectedEntry[at['code']]">-</span>
                      </ng-container>

                      <!-- 🌍 Location -->
                      <ng-container *ngIf="at['type'] === 'location'">
                        <ng-container
                          *ngIf="
                            getLocationObject(selectedEntry[at['code']]) as loc
                          "
                        >
                          <a
                            [href]="
                              'https://www.google.com/maps?q=' +
                              loc.lat +
                              ',' +
                              loc.lng
                            "
                            target="_blank"
                          >
                            {{ loc.lat }}, {{ loc.lng }}
                          </a>
                        </ng-container>
                      </ng-container>

                      <!-- 📧 Email -->
                      <ng-container *ngIf="at['type'] === 'email'">
                        <a
                          [href]="'mailto:' + selectedEntry[at['code']]"
                          target="_blank"
                        >
                          {{ selectedEntry[at["code"]] }}
                        </a>
                      </ng-container>

                      <!-- 📝 Textarea -->
                      <ng-container *ngIf="at['type'] === 'textarea'">
                        <div
                          class="custom-textarea"
                          [innerHTML]="
                            getSanitizedHtml(selectedEntry[at['code']])
                          "
                        ></div>
                      </ng-container>

                      <!-- 📅 Date & Time -->
                      <ng-container *ngIf="at['type'] === 'dateandtime'">
                        {{ getString(selectedEntry[at["code"]], at["type"]) }}
                      </ng-container>

                      <!-- ⏰ Time -->
                      <ng-container *ngIf="at['type'] === 'time'">
                        {{
                          getString1(
                            selectedEntry[at["code"]],
                            at["type"],
                            at["timeFormat"]
                          )
                        }}
                      </ng-container>

                      <!-- ⏳ iTime -->
                      <ng-container *ngIf="at['type'] === 'itime'">
                        {{
                          getStringitime(
                            selectedEntry[at["code"]],
                            at["type"],
                            at["itimeFormat"]
                          )
                        }}
                      </ng-container>

                      <!-- ✅ Boolean -->
                      <ng-container *ngIf="at['type'] === 'boolean'">
                        {{
                          selectedEntry[at["code"]] == 1
                            ? "true"
                            : selectedEntry[at["code"]] == 0
                              ? "false"
                              : ""
                        }}
                      </ng-container>

                      <!-- 📆 iDate -->
                      <ng-container *ngIf="at['type'] === 'idate'">
                        <i class="bi bi-calendar me-1"></i>
                        {{ getString(selectedEntry[at["code"]], at["type"]) }}
                      </ng-container>

                      <!-- 🗺️ Map/List/Text/Number/Other Types -->
                      <ng-container
                        *ngIf="
                          at['type'] !== 'file' &&
                          at['type'] !== 'doc' &&
                          at['type'] !== 'location' &&
                          at['type'] !== 'email' &&
                          at['type'] !== 'boolean' &&
                          at['type'] !== 'textarea' &&
                          at['type'] !== 'time' &&
                          at['type'] !== 'itime' &&
                          at['type'] !== 'dateandtime' &&
                          at['type'] !== 'idate' &&
                          at.refKey !== 1
                        "
                      >
                        {{ selectedEntry[at["code"]] || "-" }}
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "Remains.Close" | translate }}
        </button>
        <button
          mat-stroked-button
          type="button"
          color="primary"
          (click)="printModal()"
        >
          <mat-icon>print</mat-icon>
          {{ "Remains.Print" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- UPLOAD SUMMARY MODAL -->
<div
  class="modal fade"
  id="uploadSummaryModal"
  tabindex="-1"
  aria-labelledby="uploadSummaryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h6 modal-title" id="uploadSummaryModalLabel">
          {{
            uploadResult.errorRows === 0
              ? "Upload Completed Successfully"
              : "Upload Completed"
          }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="upload-summary-container ms-3">
          <div class="table-responsive">
            <table class="table table-sm align-middle table-bordered mb-0">
              <tbody>
                <tr>
                  <th style="width: 70%" class="fw-normal">Total Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.totalRows }}
                  </td>
                </tr>
                <tr>
                  <th style="width: 70%" class="fw-normal">Success Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.successRows }}
                  </td>
                </tr>
                <tr>
                  <th style="width: 70%" class="fw-normal">Error Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.errorRows }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-outline-danger"
          *ngIf="uploadResult.errorRows > 0"
          (click)="viewErrorDetails()"
          title="View Error Details"
        >
          <i class="bi bi-list"></i> View Errors
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
          title="{{ 'BUTTONS.CLOSE' | translate }}"
        >
          <i class="bi bi-x"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>